import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormClients', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/clients/issue_form_clients.html'),
        controller: 'IssueFormClientsController',
        controllerAs: 'IssueFormClientsCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            client: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/clients/issue_form_clients.component.ts